<fusioncharts *ngIf="dataSource != null" width="100%" [height]="height" type="gantt" dataFormat="json"
  [dataSource]="dataSource">
</fusioncharts>
